import { NotificationsListsTable } from 'features/notification/components/notification-list-table/notifications-list-table';
import { NotificationTopBarLists } from 'features/notification/components/top-bar/notifications-list-top-bar';
import { NotificationListsFilterFormValues, NotificationListsFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetNotificationsLists } from 'features/notification/use-cases/get-notificationlist';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: NotificationListsFilterFormValues = {
    TemplateName: undefined,
    EventId: undefined,
    TicketCategoryId: undefined,
    DeliveryType:undefined,
   Title:undefined

};

   
export const NotificationsViewList = () => {
    // const [filterValue, setFilterValue] = useState(getInitialFilterValues);
    const { params, updateParams, resetPage } =
        usePaginationParams<NotificationListsFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
        });


    const { data, refetch, isFetching } = useGetNotificationsLists(params, { retry: false });
    const handleFiltersChange = (values: NotificationListsFilterFormValuesPaginated) => {
        // setFilterValue(values);
        updateParams(values);
        resetPage();
        refetch();
    };

    return (
        <>
         
            <NotificationTopBarLists
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
                refetch={refetch}

            />


            <NotificationsListsTable
                isUsersListLoading={isFetching}
                typeReportList={data?.items as any}
                itemsCount={data?.total as number}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
            />
            <Outlet />
        </>
    );
};
